import WooCommerce from "./config"

const base_endpoint = 'products/'

export const getProducts = async (params) => {
    const products = await WooCommerce.get(`${base_endpoint}`,{...params})
    return products
}

export const getProduct = async (id) => {
    const product = await WooCommerce.get(`${base_endpoint}${id}`)
    return product
}

export const getCategories = async (params) => {
    const categories = await WooCommerce.get(`${base_endpoint}categories`,{...params})
    return categories
}
